import { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';
import type { User } from '@supabase/supabase-js';

/**
 * Checks if the authenticated user's email is approved in the waitlist.
 * Calls the is_user_approved() Postgres RPC once on mount.
 * Fails closed: RPC errors → isApproved = false.
 */
export function useApprovalStatus(user: User | null) {
  const [isApproved, setIsApproved] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user) {
      setLoading(false);
      return;
    }

    let cancelled = false;

    async function checkApproval() {
      const { data, error } = await supabase.rpc('is_user_approved');

      if (cancelled) return;

      if (error) {
        // Fail closed: treat errors as not approved
        console.error('Approval check failed:', error.message);
        setIsApproved(false);
      } else {
        setIsApproved(data === true);
      }
      setLoading(false);
    }

    checkApproval();

    return () => {
      cancelled = true;
    };
  }, [user]);

  return { isApproved, loading };
}
